import { Suspense } from 'react';
import { SellerReviewsClient } from './seller-reviews-client';

export default function Page() {
  return (
    <Suspense fallback={null}>
      <SellerReviewsClient />
    </Suspense>
  );
}
